// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sIL7","title":"styles_title__1yw6t"};